module.exports = __webpack_public_path__ + "img/icon-punti-interesse.54157706.svg";